<template style="background: #e5e5e5; font-family: 'Montserrat'">
  <div class="page-content">
    <div class="partner-attendance">
      <div class="attendance-tab">
        <AttendancePagesHeading
          pageName="Attendance"
          :date="date"
          :filterOptions="[
            { name: 'Name', value: 'name' },
            { name: 'Phone', value: 'phone' },
            { name: 'TR ID', value: 'trId' },
            // { name: 'Service Type', value: 'service_type' },
            { name: 'Type', value: 'type' },
            { name: 'Route', value: 'routeValue' },
            { name: 'Company Code', value: 'companyCode' },
            { name: 'Verification Status', value: 'attendance_status' },
            { name: 'Bill Status', value: 'bill_status' }
          ]"
          @filterSearch="filterSearch"
          :routesOptions="routesOptions"
          :companyCodes="companyCodes"
          :TRIdList="TRIdList"
          :syncLoading="syncLoading"
          @sync="manualSyncAttendanceData"
          @changeDate="changeDate"
          @downloadExcel="downloadAttendanceExcelData"
        ></AttendancePagesHeading>
      </div>
    </div>

    <div class="tab-content" id="nav-tabContent">
      <div
        class="tab-pane fade show active"
        id="nav-home"
        role="tabpanel"
        aria-labelledby="nav-attendance-tab"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <DefaultLoader v-if="isLoading"></DefaultLoader>

                <div v-else-if="filteredPartnerList.length > 0" class="row">
                  <div class="col-md-12">
                    <CustomDataTable
                      :filteredData="filteredPartnerList"
                      @fetchPaginatedData="fetchPaginatedData"
                    >
                      <template #top-right>
                        <span
                          >Current Holidays: <b>{{ currentHolidays }}</b></span
                        >
                      </template>
                      <table
                        class="table align align-middle mt-3"
                        id="datatable"
                      >
                        <thead style="background-color: #f3f3f3; height: 45px">
                          <tr>
                            <th></th>
                            <th>Driver Name</th>
                            <th>Driver Phone No</th>
                            <th>Owner Name</th>
                            <th>Assigned Routes</th>
                            <th>Company Code</th>
                            <th>Assigned CD</th>
                            <th>Service type</th>
                            <th>Completed Trips</th>
                            <th>Attendance Status</th>
                            <th>Bill Status (OPS)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template
                            v-for="partnerList in paginatedFilteredPartnerList"
                            :key="partnerList.id"
                          >
                            <tr
                              @click="checkVisibility(partnerList.user_code)"
                              class="row-click"
                            >
                              <td>
                                <span
                                  v-if="!opened.includes(partnerList.user_code)"
                                >
                                  <i class="bi bi-chevron-right"></i>
                                </span>
                                <span v-else>
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </td>
                              <td>
                                {{
                                  driverDetails.find(
                                    (driver) =>
                                      driver.user_code === partnerList.user_code
                                  )
                                    ? driverDetails.find(
                                        (driver) =>
                                          driver.user_code ===
                                          partnerList.user_code
                                      ).name
                                    : 'No Name Found'
                                }}
                              </td>
                              <td>
                                {{
                                  driverDetails.find(
                                    (driver) =>
                                      driver.user_code === partnerList.user_code
                                  )
                                    ? driverDetails.find(
                                        (driver) =>
                                          driver.user_code ===
                                          partnerList.user_code
                                      ).mobile
                                    : 'No Mobile Found'
                                }}
                              </td>
                              <td>
                                {{
                                  getDriverOwner(partnerList.user_code)
                                    ? getDriverOwner(partnerList.user_code).name
                                    : 'N/A'
                                }}
                                <!-- <span v-if="partnerList.owner">
                                  {{
                                    driverDetails.find(
                                      (driver) =>
                                        driver.user_code === partnerList.owner
                                    )
                                      ? driverDetails.find(
                                          (driver) =>
                                            driver.user_code ===
                                            partnerList.owner
                                        ).name
                                      : 'No Name Found'
                                  }}
                                </span>
                                <span v-else>N/A</span> -->
                              </td>
                              <!-- partnerList.all_route_names ? partnerList.all_route_names : 'NA' -->
                              <td>
                                {{
                                  partnerRouteList(partnerList.all_route_names)
                                }}
                              </td>
                              <td>
                                {{
                                  partnerList.all_company_codes
                                    ? partnerList.all_company_codes
                                    : 'NA'
                                }}
                              </td>
                              <td>
                                {{
                                  refinedTripCodes(
                                    partnerList.all_trip_codes,
                                    2
                                  )
                                }}
                              </td>
                              <td>
                                {{
                                  partnerList.service_type
                                    ? partnerList.service_type
                                    : 'NA'
                                }}
                              </td>
                              <td>
                                {{ partnerList.Present }}/{{
                                  partnerList.total
                                }}
                              </td>
                              <td>
                                <template
                                  v-if="
                                    partnerList.VerifiedCount !==
                                      partnerList.total ||
                                    partnerList.total <= 0
                                  "
                                >
                                  <h6 style="color: #fc7210">Unverified</h6>
                                </template>
                                <template v-else
                                  ><h6 style="color: #00ab30">
                                    Verified
                                  </h6></template
                                >
                              </td>
                              <td>
                                <span
                                  style="color: #1c2457"
                                  v-if="
                                    partnerList.total ==
                                      partnerList.ConfirmedCount &&
                                    partnerList.total > 0
                                  "
                                  >Confirmed</span
                                >
                                <span v-else>NA</span>
                              </td>
                            </tr>
                            <tr v-if="opened.includes(partnerList.user_code)">
                              <td colspan="15">
                                <h5
                                  style="
                                    font-size: 14px;
                                    font-weight: 600;
                                    margin-left: 30px;
                                  "
                                >
                                  Trips
                                </h5>
                                <div style="margin-left: 30px">
                                  <button
                                    v-if="
                                      $userPermission.has(
                                        'attendance-view-history'
                                      )
                                    "
                                    type="button"
                                    style="
                                      width: 160px;
                                      border-radius: 8px;
                                      margin-right: 12px;
                                    "
                                    @click="
                                      tripHistoryFunCall(partnerList.user_code)
                                    "
                                    data-bs-toggle="modal"
                                    data-bs-target="#tripHistoryModal"
                                    class="btn btn-light text-center"
                                  >
                                    <i class="bi bi-clock-history"></i>
                                    View History
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-primary text-center"
                                    v-if="
                                      partnerList.modality === 'fleet-variable'
                                    "
                                    @click="selectedPartnerList = partnerList"
                                    style="width: 160px; border-radius: 8px"
                                    data-bs-toggle="modal"
                                    data-bs-target="#seeTrips"
                                  >
                                    <i class="bi bi-eye"></i>
                                    See Trips
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-primary text-center"
                                    v-else-if="
                                      permissions.includes('verify-trips-modal')
                                    "
                                    @click="
                                      selectSummaryTab();
                                      getRouteWiseUserAttendance(partnerList);
                                    "
                                    style="width: 160px; border-radius: 8px"
                                    data-bs-toggle="modal"
                                    data-bs-target="#verifyTrips"
                                  >
                                    <i class="bi bi-person-check"></i>
                                    Verify Trips
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </CustomDataTable>
                  </div>
                </div>

                <NoDataMessage v-else></NoDataMessage>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <teleport to="body">
    <!-- Modal -->
    <div
      class="modal fade"
      id="tripHistoryModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">History</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <div class="row">
                <div class="table-responsive">
                  <table
                    class="table table-bordered align align-middle"
                    style="border-color: #f0f2f5"
                  >
                    <thead style="background-color: #f0f2f5">
                      <tr>
                        <th>Date</th>
                        <th>Route</th>
                        <th>Trip Time</th>
                        <th>Action</th>
                        <th>Taken By</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template
                        v-for="(history, index) in trip_history"
                        :key="index"
                      >
                        <tr>
                          <td>{{ formatDateUsingMoment(history.date) }}</td>
                          <td>{{ history.route }}</td>
                          <td>{{ history.time }}</td>
                          <td>{{ history.action }}</td>
                          <td>
                            {{
                              tripHistoryDriverDetails.find(
                                (driver) =>
                                  driver.user_code === history.taken_by
                              )
                                ? tripHistoryDriverDetails.find(
                                    (driver) =>
                                      driver.user_code === history.taken_by
                                  ).name
                                : 'No name Found'
                            }}
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <p class="justify-content-start">
                          Showing {{ this.fromHistory }} to
                          {{ this.toHistory }} of
                          {{ this.totalHistory }} entries
                        </p>
                      </div>
                      <div class="col-md-6">
                        <div class="float-end">
                          <Pagination
                            :totalPages="totalPagesHistory"
                            :total="totalHistory"
                            :currentPage="currentPageHistory"
                            :perPage="perPageHistory"
                            v-on:pagechanged="getTripHistory"
                          ></Pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <div
      class="modal fade"
      id="verifyTrips"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      :class="{ show: modalShow }"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div
          class="modal-content"
          v-if="this.filterValue.modality !== 'fleet-variable'"
        >
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalLabel"
              style="font-size: 18px; font-weight: 600; line-height: 31px"
            >
              Trip Details
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <h2
                  style="font-size: 20px; font-weight: 600; line-height: 32px"
                >
                  {{ route_wise_user_name }}
                </h2>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h4
                  style="font-size: 16px; font-weight: 500; line-height: 14px"
                >
                  CD:
                  <template
                    v-for="(
                      tripIdCode, index
                    ) in allTripRequestIdConvertStringToArrayNew"
                    :key="index"
                  >
                    <a
                      target="_blank"
                      :href="
                        '/trip-request/vehicle-request/details/' +
                        tripIdCode.trip_request_id
                      "
                      >{{ tripIdCode.trip_codes }}</a
                    >
                    <span
                      :class="
                        allTripRequestIdConvertStringToArrayNew.length - 1 ==
                        index
                          ? 'd-none'
                          : ''
                      "
                      >,
                    </span>
                  </template>
                </h4>
              </div>
            </div>
            <div v-if="selectedPartner.service_type === 'B2B'" class="row">
              <div class="col-md-12">
                <h4
                  style="font-size: 16px; font-weight: 500; line-height: 20px"
                >
                  Company Codes: {{ selectedPartner.all_company_codes }}
                </h4>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <h4
                  style="
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 14px;
                    margin: 0;
                  "
                >
                  Number of Trips:
                  <b style="font-weight: 700">{{ totalNumberOfTrips }}</b>
                </h4>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <div class="row d-flex attendance-status">
                  <div class="col-md-auto">
                    <div class="small-success-rectangle"></div>
                  </div>
                  <div class="col-md-auto">
                    <h3 style="font-size: 10px">
                      Present <b>{{ totalNumberOfPresent }}</b>
                    </h3>
                  </div>

                  <div class="col-md-auto">
                    <div class="small-danger-rectangle"></div>
                  </div>
                  <div class="col-md-auto">
                    <h3 style="font-size: 10px">
                      Absent <b>{{ totalNumberOfAbsent }}</b>
                    </h3>
                  </div>

                  <div class="col-md-auto">
                    <div class="small-pending-rectangle"></div>
                  </div>
                  <div class="col-md-auto">
                    <h3 style="font-size: 10px">
                      Pending <b>{{ totalNumberOfPending }}</b>
                    </h3>
                  </div>

                  <div class="col-md-auto">
                    <div class="small-no-action-rectangle"></div>
                  </div>
                  <div class="col-md-auto">
                    <h3 style="font-size: 10px">
                      No action taken <b>{{ totalNoActionTaken }}</b>
                    </h3>
                  </div>

                  <div class="col-md-auto">
                    <div class="small-unlisted-rectangle"></div>
                  </div>
                  <div class="col-md-auto">
                    <h3 style="font-size: 10px">
                      Unlisted <b>{{ totalUnlisted }}</b>
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-md-12">
                <nav>
                  <div
                    class="nav nav-tabs trips-nav"
                    id="nav-tab"
                    role="tablist"
                  >
                    <button
                      class="nav-link active"
                      ref="summaryTab"
                      id="summary-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#summary"
                      @click="changeEditableStatus"
                      type="button"
                      role="tab"
                      aria-controls="summary"
                      aria-selected="true"
                      :disabled="isVerifyModalLoading"
                    >
                      Summary
                    </button>
                    <template
                      v-for="(routeList, index) in route_attendance_list"
                      :key="index"
                    >
                      <button
                        :disabled="isVerifyModalLoading"
                        class="nav-link"
                        :id="
                          $format.onlyLetterString(routeList.route_name) +
                          '-tab-' +
                          $format.onlyAlphanumericString(routeList.user_code) +
                          '-' +
                          index
                        "
                        data-bs-toggle="tab"
                        :data-bs-target="
                          '#' +
                          $format.onlyLetterString(routeList.route_name) +
                          '-' +
                          $format.onlyAlphanumericString(routeList.user_code) +
                          '-' +
                          index
                        "
                        @click="
                          getUserWiseRouteDateRange(
                            routeList.route_id,
                            routeList.user_code
                          )
                        "
                        type="button"
                        role="tab"
                        aria-selected="false"
                      >
                        {{
                          routeList.route_name
                            ? routeList.route_name.slice(0, 30)
                            : 'No Route Found'
                        }}
                        <span
                          v-if="
                            routeList.route_name &&
                            routeList.route_name.length > 31
                          "
                          >...
                        </span>
                        <span v-if="routeList.company_code"
                          ><br />({{ routeList.company_code }})
                        </span>
                        <img
                          v-if="
                            routeList.total == routeList.VerifiedCount &&
                            routeList.total > 0
                          "
                          src="../assets/verified_icon.png"
                          class="rounded verified-image"
                          style="margin-bottom: 2px"
                        />
                      </button>
                    </template>
                  </div>
                </nav>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="tab-content" id="nav-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="summary"
                    role="tabpanel"
                    aria-labelledby="summary-tab"
                  >
                    <div class="row mt-3">
                      <template v-if="isSummaryLoading">
                        <div class="d-flex justify-content-center">
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="col-md-12 table-responsive">
                          <table class="align-middle table" id="summaryTable">
                            <thead style="background-color: #f3f3f3">
                              <tr>
                                <th>Routes</th>
                                <th v-if="filterValue.service_type === 'B2B'">
                                  Company
                                </th>
                                <th>Trips Completed</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(list, index) in route_attendance_list"
                                :key="index"
                              >
                                <td>
                                  <div
                                    class="text-primary"
                                    style="cursor: pointer"
                                    @click="
                                      switchTab(
                                        $format.onlyLetterString(
                                          list.route_name
                                        ) +
                                          '-tab-' +
                                          $format.onlyAlphanumericString(
                                            list.user_code
                                          ) +
                                          '-' +
                                          index
                                      )
                                    "
                                  >
                                    {{ list.route_name }}
                                  </div>
                                </td>
                                <td v-if="filterValue.service_type === 'B2B'">
                                  {{ list.company_code }}
                                </td>
                                <td>{{ list.Present }} / {{ list.total }}</td>
                                <td
                                  style="color: rgba(0, 171, 48, 0.6)"
                                  v-if="
                                    list.UnverifiedCount === 0 && list.total > 0
                                  "
                                >
                                  Verified
                                </td>
                                <td v-else style="color: #fd9144">
                                  Unverified
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </template>
                    </div>

                    <div v-if="totalVerifiedCountForShowButton === true">
                      <!-- <div class="modal-footer">
                        <div class="col-md-12">
                          <div class="row">
                            <div
                              class="col-md-6"
                              style="font-family: Montserrat"
                            >
                              <button
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                class="col-12 btn btn-light btn-lg"
                                style="
                                  background-color: #f5f5f5;
                                  color: #737373;
                                "
                              >
                                Cancel
                              </button>
                            </div>
                            <div class="col-md-6">
                              <button
                                type="button"
                                data-bs-dismiss="modal"
                                class="col-12 btn btn-primary btn-lg"
                                :class="totalUnverifiedCount"
                                @click="changeBillStatus(confirmedUserCode)"
                                :disabled="
                                  billConfirmationStatus == 'Confirmed'
                                "
                              >
                                {{
                                  billConfirmationStatus == 'Confirmed'
                                    ? 'Confirmed'
                                    : 'Confirm'
                                }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>

                  <template
                    v-for="(routeList, index) in route_attendance_list"
                    :key="index"
                  >
                    <div
                      class="tab-pane fade"
                      :id="
                        $format.onlyLetterString(routeList.route_name) +
                        '-' +
                        $format.onlyAlphanumericString(routeList.user_code) +
                        '-' +
                        index
                      "
                      role="tabpanel"
                      :aria-labelledby="
                        $format.onlyLetterString(routeList.route_name) +
                        '-tab-' +
                        $format.onlyAlphanumericString(routeList.user_code) +
                        '-' +
                        index
                      "
                    >
                      <template v-if="isRouteWiseLoading">
                        <div class="d-flex justify-content-center">
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="row">
                          <div class="col-sm-12">
                            <!-- Attendace control Buttons Start -->
                            <div
                              v-if="!totalVerifiedCountForShowButton"
                              class="trip-button-bar"
                            >
                              <button
                                v-if="isDateWiseTimeCheckable"
                                class="btn btn-sm btn-outline-primary"
                                @click="
                                  allAttendanceChecked = !allAttendanceChecked
                                "
                              >
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                  v-model="allAttendanceChecked"
                                />
                                Select All
                              </button>
                              <button
                                type="button"
                                v-if="
                                  $userPermission.has('verify-attendance') &&
                                  !isDateWiseTimeCheckable &&
                                  !isDateWiseTimeEditable
                                "
                                class="btn btn-sm btn-primary"
                                @click="verifyAttendance()"
                              >
                                <i class="bi bi-patch-check-fill"></i>
                                Verify
                              </button>
                              <button
                                type="button"
                                v-if="
                                  $userPermission.has('edit-attendance') &&
                                  !isDateWiseTimeCheckable &&
                                  !isDateWiseTimeEditable
                                "
                                @click="isDateWiseTimeEditable = true"
                                class="btn btn-sm btn-light"
                              >
                                <i class="bi bi-pencil-square"></i>
                                Edit
                              </button>
                              <button
                                type="button"
                                v-if="
                                  !isDateWiseTimeCheckable &&
                                  !isDateWiseTimeEditable
                                "
                                @click="unlistAttendance()"
                                class="btn btn-sm btn-light"
                              >
                                <i class="bi bi-x-square"></i>
                                Unlist
                              </button>
                              <button
                                type="button"
                                v-if="
                                  isDateWiseTimeEditable ||
                                  isDateWiseTimeCheckable
                                "
                                @click="resetAllToDefaultState()"
                                class="btn btn-sm btn-secondary"
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                v-if="
                                  isDateWiseTimeEditable &&
                                  !isVerifyModalLoading
                                "
                                class="btn btn-primary btn-sm"
                                @click="saveAllUpdatedAttendanceStatuses()"
                              >
                                Save
                              </button>
                              <button
                                v-if="
                                  (isDateWiseTimeEditable ||
                                    isDateWiseTimeCheckable) &&
                                  isVerifyModalLoading
                                "
                                class="btn btn-primary btn-sm"
                                type="button"
                                disabled
                              >
                                <span
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Loading...
                              </button>
                              <button
                                type="button"
                                v-if="
                                  isDateWiseTimeCheckable &&
                                  !isUnlistCheckable &&
                                  !isVerifyModalLoading
                                "
                                class="btn btn-primary btn-sm"
                                @click="verifyAllCheckedAttendance(index)"
                              >
                                Save
                              </button>
                              <button
                                type="button"
                                v-if="
                                  isDateWiseTimeCheckable &&
                                  isUnlistCheckable &&
                                  !isVerifyModalLoading
                                "
                                class="btn btn-primary btn-sm"
                                @click="unlistCheckedAttendance(index)"
                              >
                                Save
                              </button>
                            </div>
                            <!-- Attendace control Buttons End -->
                          </div>
                        </div>
                        <template
                          v-for="(routeUser, index) in routeUserWiseList"
                          :key="index"
                        >
                          <div class="row mt-3">
                            <div class="col-md-12">
                              <div class="card mb-2">
                                <div class="card-title">
                                  {{
                                    new Date(index).toString().split(' ')[0]
                                  }}, {{ index }}
                                </div>
                                <div class="card-body">
                                  <div
                                    class="trip-time-buttons d-grid gap-2 d-md-flex justify-content-md-start flex-wrap"
                                  >
                                    <template
                                      v-for="tripDetails in routeUser"
                                      :key="tripDetails.attendance_id"
                                    >
                                      <!-- check current time with trip time, if current time is less then trip time then it will disable the button -->
                                      <template
                                        v-if="
                                          tripDetails.is_future_trip === 'yes'
                                        "
                                      >
                                        <div class="attendance-button">
                                          <button
                                            type="button"
                                            class="btn btn-md rectangle-no-action disabled"
                                          >
                                            <div class="row-cols-sm-auto">
                                              <div class="col-xs">
                                                {{ tripDetails.time }}
                                              </div>
                                            </div>
                                          </button>
                                          <div
                                            class="attendance-button-tooltip"
                                          >
                                            Yet to Start
                                          </div>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <div class="attendance-button">
                                          <button
                                            type="button"
                                            @click="
                                              isDateWiseTimeEditable &&
                                              tripDetails.verification_status !==
                                                'Verified' &&
                                              tripDetails.is_future_trip ===
                                                'no' &&
                                              !tripDetails.unlisted
                                                ? changeAttendanceStatus(
                                                    tripDetails.time,
                                                    tripDetails.attendance_id,
                                                    tripDetails.trip_start_date
                                                  )
                                                : null
                                            "
                                            :class="{
                                              btn: true,
                                              'btn-md': true,
                                              'rectangle-success':
                                                tripDetails.status ===
                                                'Present',
                                              'rectangle-danger':
                                                tripDetails.status === 'Absent',
                                              'rectangle-pending':
                                                tripDetails.status ===
                                                'Pending',
                                              'unlisted-attendance':
                                                tripDetails.unlisted &&
                                                !isUnlistCheckable
                                            }"
                                          >
                                            <div class="row-cols-sm-auto">
                                              <div class="col-xs">
                                                {{ tripDetails.time }}
                                                <img
                                                  v-if="
                                                    tripDetails.verification_status ===
                                                      'Verified' &&
                                                    (!isDateWiseTimeCheckable ||
                                                      isUnlistCheckable)
                                                  "
                                                  src="../assets/verified_icon.png"
                                                  class="rounded verified-image"
                                                />
                                                <span
                                                  v-if="
                                                    tripDetails.unlisted &&
                                                    !isUnlistCheckable
                                                  "
                                                  class="unlisted-attendance-icon"
                                                  ><i
                                                    class="bi bi-x-circle-fill"
                                                  ></i
                                                ></span>

                                                <input
                                                  v-if="
                                                    isDateWiseTimeCheckable &&
                                                    (tripDetails.verification_status !==
                                                      'Verified' ||
                                                      isVerifyCheckable) &&
                                                    (tripDetails.status !==
                                                      'Pending' ||
                                                      isUnlistCheckable) &&
                                                    (!tripDetails.unlisted ||
                                                      isUnlistCheckable)
                                                  "
                                                  type="checkbox"
                                                  v-model="
                                                    selected_attendance_id[
                                                      index
                                                    ]
                                                  "
                                                  class="form-check-input"
                                                  :value="
                                                    tripDetails.attendance_id
                                                  "
                                                />
                                              </div>
                                            </div>
                                          </button>

                                          <!-- Trip Time Tooltip -->
                                          <div
                                            class="attendance-button-tooltip"
                                          >
                                            TR-{{
                                              tripDetails.trip_request_id
                                                ? tripDetails.trip_request_id
                                                : 'N/A'
                                            }}
                                            <br />
                                            Start:
                                            {{
                                              tripDetails.trip_start_time
                                                ? formatTimeUsingMoment(
                                                    tripDetails.trip_start_time
                                                  )
                                                : 'Not Found'
                                            }}
                                            <br />
                                            End:
                                            {{
                                              tripDetails.trip_end_time
                                                ? formatTimeUsingMoment(
                                                    tripDetails.trip_end_time
                                                  )
                                                : 'Not Found'
                                            }}
                                          </div>
                                        </div>
                                      </template>
                                    </template>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <Transition name="fade">
      <BillGenerateModal
        v-if="showBillGenerateModal"
        :showBillGenerateModal="showBillGenerateModal"
        :totalNumberOfTrips="totalNumberOfTrips"
        :trWiseAttendanceSummary="trWiseAttendanceSummary"
        :unlist="isUnlistCheckable"
        @closeModal="showBillGenerateModal = !showBillGenerateModal"
        @verifyAttendances="allCheckedAttendanceVerifyCode"
        @unlistAttendances="unlistCheckedAttendanceCode"
      ></BillGenerateModal>
    </Transition>
  </teleport>
  <teleport to="body">
    <!-- Modal -->
    <div
      class="modal fade partner-modal"
      id="seeTrips"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <SeeTrips
            :partnerList="selectedPartnerList"
            :date="date"
            :tzoffset="tzoffset"
            @getDriverList="getDriverList"
          ></SeeTrips>
        </div>
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <Transition name="fade">
      <VerifyOtherDriverModal
        v-if="showVerifyOtherDriverModal"
        :otherDriver="unverifiedDriverForTheTR"
        @closeModal="showVerifyOtherDriverModal = !showVerifyOtherDriverModal"
        @loadOtherDriversData="loadOtherDriversData"
      ></VerifyOtherDriverModal>
    </Transition>
  </teleport>
</template>

<script>
/* eslint-disable */
import Multiselect from '@vueform/multiselect';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';
import { onMounted, ref } from 'vue';
import Pagination from '../components/pagination/Pagination';
import http from '../config/axios';
import axiosB2BService from '../config/axiosB2BService';
import axiosB2CService from '../config/axiosB2CService';
import userService from '../config/axiosUserService';
//import Loader from '../components/lib/Loader';
import AttendancePagesHeading from '../components/attendancePages/AttendancePagesHeading.vue';
import CustomDataTable from '../components/customDataTable/CustomDataTable.vue';
import BillGenerateModal from '../components/attendancePages/BillGenerateModal.vue';
import SeeTrips from '../components/attendancePages/SeeTrips.vue';
import VerifyOtherDriverModal from '../components/attendancePages/VerifyOtherDriverModal.vue';
import userServiceAPI from '../store/userServiceAPI';

export default {
  name: 'PartnerAttendance',
  props: ['alert', 'swal'],

  components: {
    Pagination,
    Datepicker,
    Multiselect,
    CustomDataTable,
    AttendancePagesHeading,
    BillGenerateModal,
    SeeTrips,
    VerifyOtherDriverModal
  },
  data() {
    return {
      permissions: localStorage.getItem('userPermission').split(','),
      spinnerLoading: false,
      filterValue: {
        attendance_status: '',
        routeValue: '',
        companyCode: '',
        modality: localStorage.getItem('modality'),
        service_type: localStorage.getItem('serviceType'),
        name: '',
        phone: '',
        bill_status: 'NA',
        type: ''
      },
      routesOptions: [],
      companyCodes: [],
      TRIdList: [],
      partnerList: [],
      selectedPartner: {},
      paginatedFilteredPartnerList: [],
      totalPages: 0,
      total: 0,
      currentPage: 1,
      perPage: 0,
      pageCount: '',
      to: 0,
      from: 0,

      totalPagesHistory: 0,
      totalHistory: 0,
      currentPageHistory: 1,
      perPageHistory: 0,
      pageCountHistory: '',
      toHistory: 0,
      fromHistory: 0,

      isLoading: true,
      isVerifyModalLoading: false,
      paginationValue: '20',
      partner_list_id: '',
      driverDetails: [],
      tripHistoryDriverDetails: [],
      opened: [],
      user_code: [],
      route_wise_user_name: '',
      route_attendance_list: [],
      dateList: [],
      routeUserWiseList: [],
      disabled: 'disabled',
      selected_attendance_id: [],
      trip_history: [],
      perPageUserCode: '',
      current_time: new Date().toLocaleString('en-US', {
        timeZone: 'Asia/Dhaka',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      }),
      todayDate: moment(
        new Date().toLocaleString('en-US', { timeZone: 'Asia/Dhaka' })
      ).format('YYYY-MM-DD'),
      isDateWiseTimeEditable: false,
      isDateWiseTimeCheckable: false,
      isUnlistCheckable: false,
      isVerifyCheckable: false,
      editAbleDate: '',
      modalShow: false,
      confirmedUserCode: '',
      isSummaryLoading: true,
      isRouteWiseLoading: true,
      billConfirmationStatus: 'NA',
      checkableDateRows: {},
      attendanceStatus: { statuses: {} },
      selectedRouteId: null,
      selectedUserCode: null,
      startDate: '',
      driverDetailsObj: {},
      allAttendanceChecked: false,
      tzoffset: new Date().getTimezoneOffset() * 60000,
      trWiseAttendanceSummary: {},
      syncLoading: false,
      showBillGenerateModal: false,
      showVerifyOtherDriverModal: false,
      currentHolidays: null,
      date: null,
      selectedPartnerList: {}
    };
  },
  mounted() {
    // this.getB2CRouteList();
    // this.getRange();
    // this.getDriverList();
    // // this.getNumberOfTripComplete();
    // this.getDateWiseVerificationStatus();
    // this.permission = localStorage.getItem('userPermission');
    // this.syncAttendanceData();
    this.serviceTypeChange();
    this.getCompanyCodes();
    this.getCurrentHolidays();
    this.getTripRequests();
  },
  watch: {
    filterValue: {
      handler: function (newValue, oldValue) {
        if (
          oldValue.service_type !== newValue.service_type &&
          oldValue.modality === newValue.modality // Date change is in effect on change modality
        ) {
          this.serviceTypeChange();
          this.syncAttendanceData();
        } else if (oldValue.modality === newValue.modality) {
          this.getDriverList();
        }
      },
      deep: true
    },
    paginationValue: function () {
      this.getDriverList();
    },
    allAttendanceChecked: function () {
      if (this.allAttendanceChecked) {
        for (const key in this.routeUserWiseList) {
          this.selected_attendance_id[key] = this.routeUserWiseList[key]
            .filter((ele) => {
              if (
                ele.is_future_trip == 'no' &&
                (ele.status !== 'Pending' || this.isUnlistCheckable) &&
                (!ele.unlisted || this.isUnlistCheckable) &&
                (ele.verification_status !== 'Verified' ||
                  this.isVerifyCheckable)
              ) {
                return true;
              } else {
                return false;
              }
            })
            .map((ele) => {
              return ele.attendance_id;
            });
        }
      } else {
        for (const key in this.routeUserWiseList) {
          this.selected_attendance_id[key] = [];
        }
      }
    },
    deep: true
  },
  computed: {
    totalVerifiedCountForShowButton() {
      let sum = 0;

      this.route_attendance_list.forEach((data) => {
        if (data.VerifiedCount === data.total) {
          sum += 1;
        }
      });

      let verifiedLength = this.route_attendance_list.length;

      if (sum === verifiedLength) {
        return true;
      } else {
        return false;
      }
    },
    totalUnverifiedCount() {
      let sum = 0;
      this.route_attendance_list.forEach((data) => {
        //return data;
        if (data.UnverifiedCount === 0) {
          sum += 1;
        }
      });

      let verifiedLength = this.route_attendance_list.length;

      if (sum === verifiedLength) {
        return '';
      } else {
        return 'disabled';
      }
    },
    totalNumberOfTrips() {
      let totalSum = 0;
      this.route_attendance_list.forEach((data) => {
        return (totalSum += data.total);
      });
      return totalSum;
    },
    allTripRequestIdConvertStringToArrayNew() {
      let uniqueTRCodes = [];
      let tripRequestCode = [];

      this.route_attendance_list?.map((data) => {
        let tripCodes = data.all_trip_codes
          ? data.all_trip_codes.split(',')
          : [];
        let tripIds = data.trip_request_id
          ? data.trip_request_id.split(',')
          : [];

        tripCodes.forEach((tripCode, index) => {
          if (!uniqueTRCodes.includes(tripCode)) {
            uniqueTRCodes.push(tripCode);
            tripRequestCode.push({
              trip_codes: tripCode,
              user_code: data.user_code,
              trip_request_id: tripIds[index]
            });
          }
        });
      });

      return tripRequestCode;
    },
    allTripRequestIdConvertStringToArray() {
      var tripIdRequestId = [];
      this.route_attendance_list?.map((data) => {
        data.trip_request_id?.split(',').forEach((value) => {
          tripIdRequestId.push({
            trip_request_id: value,
            user_code: data.user_code
          });
        });
      });
      var tripRequestCode = [];

      this.route_attendance_list?.map((data) => {
        data.all_trip_codes?.split(',').forEach((value) => {
          tripRequestCode.push({
            trip_codes: value,
            user_code: data.user_code
          });
        });
      });

      let merged = [];
      for (let i = 0; i < tripIdRequestId.length; i++) {
        merged.push({
          ...tripIdRequestId[i],
          ...tripRequestCode.find(
            (itmInner) => itmInner.user_code === tripIdRequestId[i].user_code
          )
        });
      }
      return merged;
    },
    totalNumberOfPresent() {
      let totalSum = 0;
      this.route_attendance_list.forEach((data) => {
        if (data.Present) {
          return (totalSum += data.Present);
        }
      });
      return totalSum;
    },
    totalNumberOfPending() {
      let totalSum = 0;
      this.route_attendance_list.forEach((data) => {
        if (data.Pending) {
          return (totalSum += data.Pending);
        }
      });
      return totalSum;
    },
    totalNumberOfAbsent() {
      let totalSum = 0;
      this.route_attendance_list.forEach((data) => {
        return (totalSum += data.Absent - data.NoActionTaken);
      });
      return totalSum;
    },
    totalNoActionTaken() {
      let totalSum = 0;
      this.route_attendance_list.forEach((data) => {
        if (data.NoActionTaken) {
          return (totalSum += data.NoActionTaken);
        }
      });
      return totalSum;
    },
    totalVerified() {
      let totalSum = 0;
      this.route_attendance_list.forEach((data) => {
        if (data.VerifiedCount) {
          return (totalSum += data.VerifiedCount);
        }
      });
      return totalSum;
    },
    totalUnlisted() {
      let totalSum = 0;
      this.route_attendance_list.forEach((data) => {
        if (data.unlisted) {
          return (totalSum += data.unlisted);
        }
      });
      return totalSum;
    },
    filteredPartnerList() {
      let filteredPartners = this.partnerList;

      if (this.filterValue.name || this.filterValue.phone) {
        filteredPartners = this.partnerList.filter((partner) => {
          if (this.driverDetailsObj[partner.user_code]) {
            if (
              this.driverDetailsObj[partner.user_code].name
                .toLowerCase()
                .indexOf(this.filterValue.name.toLowerCase()) > -1 &&
              this.driverDetailsObj[partner.user_code].mobile.indexOf(
                this.filterValue.phone
              ) > -1
            ) {
              return true;
            }
            return false;
          }
          return false;
        });
      }

      return filteredPartners;
    },

    attendanceExcelData() {
      return this.paginatedFilteredPartnerList.map((item) => ({
        Name: this.driverDetails.find(
          (driver) => driver.user_code === item.user_code
        )
          ? this.driverDetails.find(
              (driver) => driver.user_code === item.user_code
            ).name
          : 'No Name Found',
        'Phone No': this.driverDetails.find(
          (driver) => driver.user_code === item.user_code
        )
          ? this.driverDetails.find(
              (driver) => driver.user_code === item.user_code
            ).mobile
          : 'No Mobile Found',
        'Assigned Routes': item.all_route_names?.replace(/,/g, '->'),
        'Company Code': item.company_code ? item.company_code : 'NA',
        'Assigned CD': this.refinedTripCodes(item.all_trip_codes, 2),
        'Service type': item.service_type ? item.service_type : 'NA',
        'Completed Trips': item.Present + '/' + item.total,
        'Attendance Status': this.attendanceStatusCheck(item),
        'Bill Status (OPS)':
          item.total == item.ConfirmedCount ? 'Confirmed' : 'N/A'
      }));
    }
  },
  methods: {
    attendanceStatusCheck(item) {
      if (item.VerifiedCount !== item.total || item.total <= 0) {
        return 'Unverified';
      } else {
        return 'Verified';
      }
    },

    fetchPaginatedData(paginatedData) {
      this.paginatedFilteredPartnerList = paginatedData;
    },
    partnerRouteList(routes) {
      let routesList = [];
      routes?.split(',').forEach((value) => {
        routesList.push(value);
      });
      if (routesList.length > 1) {
        return routesList[0] + ' ' + '...';
      } else {
        return routesList[0];
      }
    },
    refinedTripCodes(codes, numOfItems) {
      if (codes) {
        let refinedCodes = [];
        codes?.split(',').forEach((value) => {
          if (refinedCodes.length < numOfItems) {
            refinedCodes.push(value);
          } else if (refinedCodes.length == numOfItems) {
            refinedCodes[numOfItems - 1] =
              refinedCodes[numOfItems - 1] + ' ...';
          }
        });
        return refinedCodes.join(', ');
      }
      return 'NA';
    },
    totalVerifiedCount(date) {
      let sum = 0;
      const getIndexDateDetails = this.routeUserWiseList[date];
      getIndexDateDetails.forEach((data) => {
        if (data.verification_status === 'Verified') {
          sum += 1;
        }
      });

      let verifiedLength = Object.values(this.routeUserWiseList).length;

      if (sum === verifiedLength) {
        return 'disabled';
      } else {
        return '';
      }
    },
    getDriverOwner(user_code) {
      let owner = null;

      this.driverDetails.forEach((driver) => {
        if (driver.user_code === user_code && driver.roleInfo) {
          driver.roleInfo.forEach((role) => {
            if (
              role.linked_role_user &&
              role.linked_role_user.role_name === 'Owner' &&
              role.linked_role_user.user_info
            ) {
              owner = role.linked_role_user.user_info;
            }
          });
        }
      });

      return owner;
    },
    changeBillStatus(user_code) {
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      // let startDate = this.startDate ? this.startDate : newStartDate;

      var billobject = {
        start_date: startDate,
        end_date: endDate,
        serviceType: this.filterValue.service_type,
        user_code: user_code
      };
      this.$swal({
        title: 'Are you sure you want to confirm these trips?',
        text: 'Once confirmed, you can not undo this action!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, change it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          http
            .patch('/v2/partners/attendance/bill_status', billobject)
            .then((response) => {
              if (response.status === 200) {
                this.getDriverList();
                this.$swal({
                  title: 'Success!',
                  text: 'Bill status changed successfully!',
                  icon: 'success',
                  type: 'success',
                  timer: 1000
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.errored = true;
            });
        } else {
          this.$swal({
            title: 'Opps!!',
            text: 'Your bill status has not changed!',
            icon: 'warning',
            type: 'warning'
          });
        }
      });
    },
    changeEditableStatus() {
      this.isDateWiseTimeEditable = false;
    },
    switchTab(id) {
      document.getElementById(id).click();
    },
    closeModal() {
      this.isDateWiseTimeEditable = false;
      this.isDateWiseTimeCheckable = false;
      this.allAttendanceChecked = false;
      this.modalShow = false;
      document.getElementById('verifyTrips').style.display = 'none';
    },
    editAllDateWiseTime() {
      this.isDateWiseTimeEditable = true;
    },

    tripHistoryFunCall(user_code) {
      this.perPageUserCode = user_code;
      this.getTripHistory(null);
    },
    getTripHistory(value) {
      http
        .get(
          `/v2/partners/attendance/action-history?page=${value}&serviceType=${this.filterValue.service_type}&userCode=${this.perPageUserCode}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.trip_history = response.data.data;
            this.totalHistory = response.data.total;
            this.totalPagesHistory = response.data.last_page;
            this.currentPageHistory = response.data.current_page;
            this.perPageHistory = response.data.per_page;
            this.toHistory = response.data.to;
            this.fromHistory = response.data.from;

            let userCodes = this.trip_history.map((trip) => trip.taken_by);
            userServiceAPI.getUserDetails(userCodes).then((callRes) => {
              this.tripHistoryDriverDetails = callRes.data.data;
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    mapCheckableDateRows(routeUserWiseList) {
      for (const key in routeUserWiseList) {
        this.checkableDateRows[key] = false;
      }
    },
    mapAttendanceRows(routeUserWiseList) {
      for (const key in routeUserWiseList) {
        this.selected_attendance_id[key] = [];
      }
    },
    resetAllToDefaultState() {
      this.isDateWiseTimeEditable = false;
      this.isDateWiseTimeCheckable = false;
      this.isUnlistCheckable = false;
      this.isVerifyCheckable = false;
      this.allAttendanceChecked = false;
      this.editAbleDate = '';
      this.attendanceStatus.statuses = {};
      this.getUserWiseRouteDateRange(
        this.selectedRouteId,
        this.selectedUserCode
      );
    },
    makeBillGenerateMsg() {
      let billGenerateMsg =
        '<h5><b>Total Trip: ' + this.totalNumberOfTrips + '</b></h5>';
      for (const key in this.trWiseAttendanceSummary) {
        billGenerateMsg +=
          '<div class="billGenerateMsg"><b style="text-align: left">' +
          (this.trWiseAttendanceSummary[key].trip_code
            ? this.trWiseAttendanceSummary[key].trip_code
            : 'No TR Found!') +
          '</b><ul><li>Total Trip: ' +
          this.trWiseAttendanceSummary[key].total +
          '</li><li>Present: ' +
          this.trWiseAttendanceSummary[key].Present +
          '</li><li>Absent: ' +
          this.trWiseAttendanceSummary[key].Absent +
          '</li></ul></div>';
      }
      billGenerateMsg +=
        '<h5 style="margin-bottom: 0; margin-top: 30px"><b>Do you want to generate the Bill?</b></h5>';
      return billGenerateMsg;
    },
    getCheckedAttendanceList() {
      let checkedAttendances = [];
      for (const key1 in this.selected_attendance_id) {
        for (const key2 in this.selected_attendance_id[key1]) {
          checkedAttendances.push(this.selected_attendance_id[key1][key2]);
        }
      }
      return checkedAttendances;
    },
    allCheckedAttendanceVerifyCode() {
      let attendances = this.getVerifiedCheckedAttendance();
      let checkedAttendances = this.getCheckedAttendanceList();
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      if (attendances.length > 0) {
        this.isVerifyModalLoading = true;
        const attendance_id_set = new Set(checkedAttendances);
        let format_selected_attendance_id = [];
        attendance_id_set.forEach((data) => {
          format_selected_attendance_id.push(data);
        });

        http
          .patch(`v2/partners/attendance/verification_status`, {
            verified_attendance_ids: format_selected_attendance_id,
            verified_trips: attendances,
            start_date: startDate,
            end_date: endDate,
            user_code: this.selectedPartner.user_code,
            modality: this.filterValue.modality,
            service_type: this.filterValue.service_type,
            type: this.filterValue.type
          })
          .then((response) => {
            this.isVerifyModalLoading = false;
            if (response.status === 200) {
              attendance_id_set.forEach((attendance_id) => {
                let attendance = null;
                for (const key in this.routeUserWiseList) {
                  attendance = this.routeUserWiseList[key].find(
                    (data) => data.attendance_id === attendance_id
                  );
                  if (attendance) break;
                }

                if (attendance) {
                  this.getUserWiseRouteDateRange(
                    attendance.route_id,
                    attendance.user_code
                  );
                }
              });
              if (response.data?.data?.unverified_driver_for_the_TR) {
                this.showVerifyOtherDriverModal = true;
                this.unverifiedDriverForTheTR =
                  response.data.data.unverified_driver_for_the_TR;
              } else {
                this.$swal({
                  icon: 'success',
                  title: 'Success',
                  text: 'Checked trips verified successfully!',
                  showConfirmButton: false,
                  timer: 1000
                });
              }
              this.mapAttendanceRows(this.routeUserWiseList);
              this.resetAllToDefaultState();
              this.getRouteWiseUserAttendance(this.selectedPartner);
              this.getDriverList(false);
            }
          })
          .catch((error) => {
            this.isVerifyModalLoading = false;
            console.log(error.response);
            this.errored = true;
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: error.response.data?.message
            });
          });
      } else {
        this.$swal({
          icon: 'warning',
          title: 'Oops...',
          text: 'Nothing to verify!'
        });
      }
    },
    verifyAllCheckedAttendance(key) {
      let checkedAttendances = this.getCheckedAttendanceList();

      if (
        this.totalNumberOfTrips ===
        this.totalVerified +
          checkedAttendances.length -
          this.route_attendance_list[key]?.VerifiedCount
      ) {
        this.showBillGenerateModal = true;
      } else {
        this.allCheckedAttendanceVerifyCode();
      }
    },
    getUnlistedCheckedAttendance() {
      let attendances = [];
      for (const key1 in this.routeUserWiseList) {
        for (const key2 in this.routeUserWiseList[key1]) {
          if (
            this.routeUserWiseList[key1][key2].is_future_trip === 'no' &&
            this.routeUserWiseList[key1][key2].verification_status ===
              'Unverified'
          ) {
            if (
              this.selected_attendance_id[key1].includes(
                this.routeUserWiseList[key1][key2].attendance_id
              )
            ) {
              attendances.push({
                attendance_id: this.routeUserWiseList[key1][key2].attendance_id,
                unlisted: true
              });
            } else {
              attendances.push({
                attendance_id: this.routeUserWiseList[key1][key2].attendance_id,
                unlisted: false
              });
            }
          }
        }
      }
      return attendances;
    },
    getVerifiedCheckedAttendance() {
      let attendances = [];
      for (const key1 in this.routeUserWiseList) {
        for (const key2 in this.routeUserWiseList[key1]) {
          if (
            this.routeUserWiseList[key1][key2].is_future_trip === 'no' &&
            !this.routeUserWiseList[key1][key2].unlisted
          ) {
            if (
              this.selected_attendance_id[key1].includes(
                this.routeUserWiseList[key1][key2].attendance_id
              )
            ) {
              attendances.push({
                attendance_id: this.routeUserWiseList[key1][key2].attendance_id,
                verified: true
              });
            } else {
              attendances.push({
                attendance_id: this.routeUserWiseList[key1][key2].attendance_id,
                verified: false
              });
            }
          }
        }
      }
      return attendances;
    },
    unlistAttendance() {
      this.isDateWiseTimeCheckable = true;
      this.isUnlistCheckable = true;
      for (const key1 in this.routeUserWiseList) {
        for (const key2 in this.routeUserWiseList[key1]) {
          if (this.routeUserWiseList[key1][key2].unlisted) {
            this.selected_attendance_id[key1].push(
              this.routeUserWiseList[key1][key2].attendance_id
            );
          }
        }
      }
    },
    verifyAttendance() {
      this.isDateWiseTimeCheckable = true;
      this.isVerifyCheckable = true;

      for (const key1 in this.routeUserWiseList) {
        for (const key2 in this.routeUserWiseList[key1]) {
          if (
            this.routeUserWiseList[key1][key2].verification_status ===
            'Verified'
          ) {
            this.selected_attendance_id[key1].push(
              this.routeUserWiseList[key1][key2].attendance_id
            );
          }
        }
      }
    },
    unlistCheckedAttendanceCode() {
      this.isVerifyModalLoading = true;
      let attendances = this.getUnlistedCheckedAttendance();
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      if (attendances.length > 0) {
        http
          .patch(`v2/partners/attendance/unlisted`, {
            unlisted_trips: attendances,
            start_date: startDate,
            end_date: endDate,
            user_code: this.selectedPartner.user_code,
            service_type: this.filterValue.service_type,
            modality: this.filterValue.modality,
            type: this.filterValue.type
          })
          .then((response) => {
            this.isVerifyModalLoading = false;
            if (response.status === 200) {
              attendances.forEach((attendanceObj) => {
                let attendance_id = attendanceObj.attendance_id;
                let attendance = null;
                for (const key in this.routeUserWiseList) {
                  attendance = this.routeUserWiseList[key].find(
                    (data) => data.attendance_id === attendance_id
                  );
                  if (attendance) break;
                }
                if (attendance) {
                  this.getUserWiseRouteDateRange(
                    attendance.route_id,
                    attendance.user_code
                  );
                }
              });
              if (response.data?.data?.unverified_driver_for_the_TR) {
                this.showVerifyOtherDriverModal = true;
                this.unverifiedDriverForTheTR =
                  response.data.data.unverified_driver_for_the_TR;
              } else {
                this.$swal({
                  icon: 'success',
                  title: 'Success',
                  text: 'Successfully unlisted marked attendance!',
                  showConfirmButton: false,
                  timer: 1000
                });
              }
              this.mapAttendanceRows(this.routeUserWiseList);
              this.resetAllToDefaultState();
              this.getRouteWiseUserAttendance(this.selectedPartner);
              this.getDriverList(false);
            }
          })
          .catch((error) => {
            console.log(error);
            this.isVerifyModalLoading = false;
            this.errored = true;
          });
      } else {
        this.$swal({
          icon: 'warning',
          title: 'Oops...',
          text: 'Nothing to unlist!'
        });
      }
    },
    unlistCheckedAttendance(key) {
      let attendances = this.getUnlistedCheckedAttendance();
      let unlistedAttendanceLength = 0;
      attendances.forEach((element) => {
        if (element.unlisted) {
          unlistedAttendanceLength++;
        }
      });
      let newUnlistedAttendanceLength =
        unlistedAttendanceLength - this.route_attendance_list[key]?.unlisted;

      if (
        this.totalNumberOfTrips - newUnlistedAttendanceLength ===
        this.totalVerified
      ) {
        this.showBillGenerateModal = true;
      } else {
        this.unlistCheckedAttendanceCode();
      }
    },
    formatDateUsingMoment(date) {
      return moment(date).format('DD.MM.YYYY');
    },
    formatTimeUsingMoment(time) {
      return moment(time, 'HH:mm').format('hh:mm A');
    },
    changeAttendanceStatus(time, attendance_id, date) {
      const attendance = this.routeUserWiseList[date].find(
        (data) => data.attendance_id === attendance_id
      );
      var status = '';

      if (attendance.status === 'Absent') {
        status = 'Present';
      } else if (attendance.status === 'Present') {
        status = 'Absent';
      } else {
        status = 'Absent';
      }

      attendance.status = status;
      if (this.attendanceStatus.statuses[attendance_id]) {
        this.attendanceStatus.statuses[attendance_id].status = status;
      } else {
        this.attendanceStatus.statuses[attendance_id] = {
          attendance_id: attendance_id,
          status: status
        };
      }
    },
    saveAllUpdatedAttendanceStatuses() {
      if (Object.keys(this.attendanceStatus.statuses).length > 0) {
        this.isVerifyModalLoading = true;
        http
          .patch(`v2/partners/attendance/status`, this.attendanceStatus)
          .then((response) => {
            this.isVerifyModalLoading = false;
            if (response.status === 200) {
              this.$swal({
                icon: 'success',
                title: 'Success',
                text: 'Attendance statuses updated successfully!',
                showConfirmButton: false,
                timer: 1000
              });
              this.resetAllToDefaultState();
              this.getRouteWiseUserAttendance(this.selectedPartner);
              this.getDriverList(false);
            }
          })
          .catch((error) => {
            this.isVerifyModalLoading = false;
            console.log(error);
            this.errored = true;
          });
      } else {
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'Please update an attendance status first!'
        });
      }
    },
    getUserWiseRouteDateRange(route_id, user_code) {
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      // let startDate = this.startDate ? this.startDate : newStartDate;
      this.isDateWiseTimeEditable = false;
      this.isDateWiseTimeCheckable = false;
      this.allAttendanceChecked = false;
      // this.isRouteWiseLoading = true;

      http
        .get(
          `/v2/partners/attendance/trip-start-date/${route_id}/${user_code}?start_date=${startDate}&end_date=${endDate}&modality=${this.filterValue.modality}&serviceType=${this.filterValue.service_type}&type=${this.filterValue.type}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.routeUserWiseList = response.data.data;
            this.isRouteWiseLoading = false;
            this.mapCheckableDateRows(this.routeUserWiseList);
            this.mapAttendanceRows(this.routeUserWiseList);
            this.selectedRouteId = route_id;
            this.selectedUserCode = user_code;
            // this.modalShow = true;
            // document.getElementById('verifyTrips').classList.remove('show');
            // document.getElementById('verifyTrips').removeAttribute('style');
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    checkVisibility(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.length = 0;
        this.opened.push(id);
        let getPartnerListId = this.partnerList.find(
          (partnerList) => partnerList.user_code == id
        );
        this.partner_list_id = getPartnerListId.user_code;
      }
    },
    getB2CRouteList() {
      axiosB2CService
        .get('/all-route')
        .then((response) => {
          this.b2cRouteList = response.data;
          let routeList = response.data;
          routeList.forEach((object) => {
            this.routesOptions.push({
              value: object.id,
              label: object.name
            });
          });
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    getB2BRouteList() {
      axiosB2BService
        .get('/api/all-routes')
        .then((response) => {
          let routeList = response.data.data;
          routeList.forEach((object) => {
            this.routesOptions.push({
              value: object.id,
              label: object.name
            });
          });
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    getCompanyCodes() {
      axiosB2BService
        .get('/api/all-companies')
        .then((response) => {
          let companyCodeList = response.data.data;
          companyCodeList.forEach((object) => {
            this.companyCodes.push({
              value: object.companyCode,
              label: object.companyCode
            });
          });
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    syncAttendanceData() {
      this.isLoading = true;
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      let difference_between_day_from_two_dates = Math.round(
        (new Date(endDate).getTime() - new Date(startDate).getTime()) /
          (1000 * 3600 * 24)
      );
      let newStartDate = moment(
        moment(startDate).add(1, 'd').format('YYYY-MM-DD')
      );
      // this.startDate = newStartDate['_i'];
      // let latestStartDate = newStartDate['_i'];
      this.startDate = startDate;
      // let latestStartDate = startDate;
      // if (difference_between_day_from_two_dates <= 7) {
      http
        .post(
          `/v2/partners/attendance/sync?start_date=${startDate}
        &end_date=${endDate}&serviceType=${this.filterValue.service_type}&modality=${this.filterValue.modality}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.getDriverList();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.errored = true;
          console.log(error.response.data?.meassage);
          this.$partnerSwal.errorToast.fire({
            title: 'Failed to sync attendance data!',
            text: error.response.data?.message
          });
        });
      // } else {
      //   this.$swal({
      //     title: 'Sorry!',
      //     text: 'Please select two week date range!',
      //     icon: 'warning',
      //     type: 'warning'
      //   });
      //   this.isLoading = false;
      // }
    },
    manualSyncAttendanceData() {
      this.isLoading = true;
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      let difference_between_day_from_two_dates = Math.round(
        (new Date(endDate).getTime() - new Date(startDate).getTime()) /
          (1000 * 3600 * 24)
      );
      let newStartDate = moment(
        moment(startDate).add(1, 'd').format('YYYY-MM-DD')
      );
      // this.startDate = newStartDate['_i'];
      // let latestStartDate = newStartDate['_i'];
      this.startDate = startDate;
      // let latestStartDate = startDate;
      // if (difference_between_day_from_two_dates <= 7) {
      this.syncLoading = true;
      http
        .post(
          `/v2/partners/attendance/manual-sync?start_date=${startDate}
        &end_date=${endDate}&serviceType=${this.filterValue.service_type}&modality=${this.filterValue.modality}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.syncLoading = false;
            this.getDriverList();
          }
        })
        .catch((error) => {
          this.syncLoading = false;
          this.isLoading = false;
          this.errored = true;
          console.log(error.response.data?.meassage);
          this.$partnerSwal.errorToast.fire({
            title: 'Failed to sync attendance data!',
            text: error.response.data?.message
          });
        });
      // } else {
      //   this.$swal({
      //     title: 'Sorry!',
      //     text: 'Please select two week date range!',
      //     icon: 'warning',
      //     type: 'warning'
      //   });
      //   this.isLoading = false;
      // }
    },
    mapDriverDetailsIntoObject() {
      this.driverDetails.forEach((driver) => {
        this.driverDetailsObj[driver.user_code] = driver;
      });
    },
    mapDriverInfoInDriverDetails() {
      this.partnerList.forEach((partner) => {
        partner.driver_name = this.driverDetailsObj[partner.user_code]?.name
          ? this.driverDetailsObj[partner.user_code].name
          : 'N/A';
        partner.driver_mobile = this.driverDetailsObj[partner.user_code]?.mobile
          ? this.driverDetailsObj[partner.user_code].mobile
          : 'N/A';
      });
    },
    filterSearch(searchValues) {
      this.filterValue = {
        attendance_status: '',
        routeValue: '',
        companyCode: '',
        modality: localStorage.getItem('modality'),
        service_type: localStorage.getItem('serviceType'),
        type: '',
        name: '',
        phone: '',
        bill_status: 'NA'
      };
      for (const key in searchValues) {
        this.filterValue[key] = searchValues[key];
      }
    },
    changeDate(selectedDate, modalityChanged) {
      if (!this.date || modalityChanged) {
        this.date = selectedDate;
        this.syncAttendanceData();
      } else {
        this.date = selectedDate;
        this.getDriverList();
      }
    },
    getDriverList(showLoading = true) {
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10)
        ? this.date[0].toISOString().substring(0, 10)
        : null;
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10)
        ? this.date[1].toISOString().substring(0, 10)
        : null;

      this.startDate = startDate;
      // let startDate = this.startDate ? this.startDate : newStartDate;
      this.isLoading = showLoading;
      var url;

      url = `/v2/partners/attendance/user?start_date=${startDate}&end_date=${endDate}&service_type=${
        this.filterValue.service_type || ''
      }&modality=${this.filterValue.modality || ''}&verification_status=${
        this.filterValue.attendance_status || ''
      }&route_id=${this.filterValue.routeValue || ''}&bill_status=${
        this.filterValue.bill_status || ''
      }&user_code=${this.user_code || ''}&companyCode=${
        this.filterValue.companyCode || ''
      }&type=${this.filterValue.type || ''}
        &tr_id=${this.filterValue.trId || ''}`;
      http
        .get(url)
        .then((response) => {
          if (response.status === 200) {
            this.partnerList = response.data.data;
            // this.total = response.data.data.total;
            // this.totalPages = response.data.data.last_page;
            // this.currentPage = response.data.data.current_page;
            // this.perPage = response.data.data.per_page;
            // this.to = response.data.data.to;
            // this.from = response.data.data.from;

            let userCodes = this.partnerList.map((user) => user.user_code);
            // let ownerCodes = [];
            // this.partnerList.forEach((element) => {
            //   if (element.owner && !userCodes.includes(element.owner)) {
            //     ownerCodes.push(element.owner);
            //   }
            // });
            // this.getDriverDetails([...userCodes, ...ownerCodes]);

            userServiceAPI
              .getUserDetails(userCodes)
              .then((callRes) => {
                this.isLoading = false;
                this.driverDetails = callRes.data.data;
                this.driverDetailsObj = userServiceAPI.mapUsersIntoObject(
                  callRes.data.data
                );
              })
              .catch(() => {
                this.isLoading = false;
              });
          }

          // setTimeout(() => {
          //   this.isLoading = false;
          // }, 1500);
        })
        .catch((error) => {
          this.isLoading = false;
          this.errored = true;
          console.log(error.response.data?.meassage);
          this.$partnerSwal.errorToast.fire({
            title: 'Error fetching data!',
            text: error.response.data?.message
          });
        });
    },
    // getDriverDetails(id, callback) {
    //   userService
    //     .get(
    //       `v1/users?user_code=${id.join(
    //         ','
    //       )}&fields=name,mobile,user_code,email,status,role&limit=500`
    //     )
    //     .then((response) => {
    //       callback(response);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    searchWithName() {
      this.user_code = [];
      var url = `v1/users/search?field=name&return=mobile,name,user_code&key=${
        this.filterValue.name || ''
      }`;
      userService
        .get(url)
        .then((response) => {
          let user_info = response.data.data;
          user_info.forEach((users) => {
            this.user_code.push(users.user_code);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchWithMobile() {
      this.user_code = [];
      var url = `v1/users/search?field=mobile&return=mobile,name,user_code&key=${
        this.filterValue.phone || ''
      }`;
      userService
        .get(url)
        .then((response) => {
          let user_info = response.data.data;
          user_info.forEach((users) => {
            this.user_code.push(users.user_code);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectSummaryTab() {
      this.$refs.summaryTab.click();
    },
    getRouteWiseUserAttendance(partnerList) {
      let user_code = partnerList.user_code;
      this.billConfirmationStatus = 'NA';
      this.selectedPartner = partnerList;
      if (
        partnerList.total &&
        partnerList.ConfirmedCount &&
        partnerList.total > 0 &&
        partnerList.total == partnerList.ConfirmedCount
      ) {
        this.billConfirmationStatus = 'Confirmed';
      }

      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);

      this.route_wise_user_name = this.getUserName(user_code);
      this.selected_attendance_id = [];
      this.confirmedUserCode = '';
      // let startDate = this.startDate ? this.startDate : newStartDate;

      // this.isSummaryLoading = true;

      http
        .get(
          `/v2/partners/attendance/route/${user_code}?start_date=${startDate}&end_date=${endDate}&modality=${this.filterValue.modality}&serviceType=${this.filterValue.service_type}&type=${this.filterValue.type}`
        )
        .then((response) => {
          if (response.status === 200) {
            this.route_attendance_list = response.data.data.route_wise_data;
            this.trWiseAttendanceSummary = response.data.data.summary;
            this.confirmedUserCode = user_code;
            this.isSummaryLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUserName(user_code) {
      return this.driverDetails.find((driver) => driver.user_code === user_code)
        ? this.driverDetails.find((driver) => driver.user_code === user_code)
            .name
        : 'No User Found';
    },

    serviceTypeChange() {
      if (this.filterValue.service_type === 'B2C') {
        this.routesOptions = [];
        // this.filterValue.routeValue = '';
        this.getB2CRouteList();
      } else {
        this.routesOptions = [];
        // this.filterValue.routeValue = '';
        this.getB2BRouteList();
      }
      this.TRIdList=[];
      this.getTripRequests();
    },

    createButtonSpinnerAnimation() {
      this.spinnerLoading = !false;
      setTimeout(() => {
        this.spinnerLoading = !true;
      }, 1000);
    },
    windowLocationReload() {
      window.location.reload();
    },

    allTripTimeVerified(routeUser) {
      let isVerified = true;

      routeUser.forEach((tripDetails) => {
        if (tripDetails.verification_status !== 'Verified') {
          isVerified = false;
        }
      });

      return isVerified;
    },

    // downloadAttendanceExcelData(arrData) {
    //   let csvContent = 'data:text/xlsx;charset=utf-8,';
    //   csvContent += [
    //     Object.keys(arrData[0]).join(';'),
    //     ...arrData.map((item) => Object.values(item).join(';'))
    //   ]
    //     .join('\n')
    //     .replace(/(^\[)|(\]$)/gm, '');

    //   const data = encodeURI(csvContent);
    //   const link = document.createElement('a');
    //   link.setAttribute('href', data);
    //   link.setAttribute('download', 'attendance.xlsx');
    //   link.click();
    // },
    downloadAttendanceExcelData() {
      let startDate = new Date(this.date[0] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      let endDate = new Date(this.date[1] - this.tzoffset)
        .toISOString()
        .substring(0, 10);
      // let startDate = this.startDate ? this.startDate : newStartDate;
      var url;
      url = `v2/partners/attendance/export?start_date=${startDate}&end_date=${endDate}&serviceType=${this.filterValue.service_type}&type=${this.filterValue.type}`;
      document.getElementById('globalLoadingModalBtn').click();

      http
        .get(url, { responseType: 'arraybuffer' })
        .then((response) => {
          document.getElementById('globalLoadingModalBtn').click();
          const url = URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `attendance_${startDate}_${endDate}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          document.getElementById('globalLoadingModalBtn').click();
          console.log(error);
          this.errored = true;
        });
    },
    getCurrentHolidays() {
      http
        .get('v2/settings/holidays')
        .then((response) => {
          if (response.status == 200) {
            this.currentHolidays = response.data?.data?.count;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert(error.response.data.msg);
          console.log(error);
        });
    },
    loadOtherDriversData() {
      this.selectSummaryTab();
      this.getRouteWiseUserAttendance(this.unverifiedDriverForTheTR);
      this.showVerifyOtherDriverModal = !this.showVerifyOtherDriverModal;
    },
    getTripRequests() {
      http
        .get(
          `v2/partners/triprequests?pagination_value=500&page=1&routeName=&requestedDate=&distance=&time=&companyCode=&dutyDays=&dutyStartDate=&serviceType=${this.filterValue.service_type}&vehicleType=&modality=${this.filterValue.modality}&requestedBy=&status=`
          // &assignedDriver=${this.filterValues.assignedDriver}
        )
        .then((response) => {
          let trLists = response.data.data.data;
            trLists.forEach(res=>{
                this.TRIdList.push(
                    {
                    value: res.id,
                    label: res.trip_code
                    }
                );
            });
          
        })
    }
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.verified-image {
  height: 14px;
  width: 14px;
  margin: 0px auto;
}

.partner-attendance,
h1 {
  font-family: Montserrat;
  font-weight: 600;
  size: 24px;
  line-height: 24px;
}

.attendance,
h3 {
  font-size: 14px;
  color: #000000;
  line-height: 14px;
  font-family: Montserrat;
}

/* New Verify Trips Style Start */
.attendance-status h3 {
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
}
.attendance-status h3 b {
  font-size: 14px;
  font-weight: 700;
  line-height: 14px;
}

#verifyTrips .modal-header {
  padding: 15px 22px;
}
#verifyTrips .modal-body {
  padding: 22px;
}

#verifyTrips table {
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.07);
  border-radius: 4px 4px 0px 0px;
}
#verifyTrips table thead tr th {
  font-size: 13px;
  font-weight: 500;
  padding: 11px 15px;
}
#verifyTrips table tbody tr td {
  font-size: 13px;
  font-weight: 400;
  padding: 17px 15px;
}
#verifyTrips .card {
  padding: 1rem 1rem;
  border-radius: 7px;
}
#verifyTrips .card-body {
  padding: 0;
}
#verifyTrips .nav-link {
  font-size: 13px;
  font-weight: 500;
  color: #000;
}
.trips-nav .active {
  color: #652f8f !important;
}

.trip-time-buttons button {
  width: 113px;
  height: 50px;
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  position: relative;
}
.trip-time-buttons input {
  position: absolute;
  top: 0px;
  right: 4px;
  width: 14px;
  height: 14px;
}
.trip-time-buttons img {
  position: absolute;
  top: 4px;
  right: 4px;
  /* width: 14px;
  height: 14px; */
}

.trip-status-change-buttons > div {
  float: right;
  margin-left: 12px;
}
.trip-status-change-buttons > div > button {
  width: 80px;
}

.trip-button-bar {
  float: right;
  margin-top: 15px;
}
.trip-button-bar button {
  margin-left: 10px;
}
/* New Verify Trips Style End */

#syncButton {
  background: #d9e1ed;
  height: 39px;
  width: 133px;
}

#excelButton {
  background: #d9e1ed;
}

.date-section h5 span {
  /*color: #2F3676;*/
  color: white;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 14px;
}

ul {
  list-style: none;
  float: left;
  margin: 0 auto;
  padding: initial;
}

li {
  float: left;
  width: 79px;
  line-height: 80px;
  margin: 0;
}

li a {
  width: 100px;
  text-decoration: none;
  color: black;
  text-decoration: none;
}

.custom-btn {
  color: #ffffff;
  background-color: #33f369;
}

.custom-btn2 {
  background-color: #262c66;
  color: white;
}

.custom-btn3 {
  background-color: #c4c4c4;
  color: white;
  border-color: #c4c4c4;
}

attendance-table {
  /*margin-bottom: 103px;*/
}

.driver-name {
  font-family: Montserrat;
  font-weight: 700;
  font-style: italic;
  font-size: 28px;
  line-height: 14px;
}

.multiselect-placeholder {
  font-size: 12px;
}

#datatable {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 12px;
}

#summaryTable {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 12px;
  margin-bottom: 30px;
}

table {
  font-family: Montserrat;
}

table tbody {
  border-top: none !important;
}

table th,
table td {
  vertical-align: middle;
}

#summaryTable td {
  font-size: 15px;
}

.small-success-rectangle {
  position: absolute;
  width: 14px;
  height: 14px;
  background: rgba(0, 171, 48, 0.6);
  border-radius: 4px;
}

.small-danger-rectangle {
  position: absolute;
  width: 14px;
  height: 14px;
  background: rgba(240, 20, 20, 0.78);
  border-radius: 4px;
}

.small-pending-rectangle {
  position: absolute;
  width: 14px;
  height: 14px;
  background: #ffab70;
  border-radius: 4px;
}

.small-no-action-rectangle {
  position: absolute;
  width: 14px;
  height: 14px;
  background: #c4c4c4;
  border-radius: 4px;
}
.small-unlisted-rectangle {
  position: absolute;
  width: 14px;
  height: 14px;
  background: #f3f2f2;
  border-radius: 4px;
}

.rectangle-danger {
  /*position: absolute;*/
  /*width: 120px;*/
  /*height: 60px;*/
  background: rgba(240, 20, 20, 0.78);
  border-radius: 7px;
  border-color: rgba(240, 20, 20, 0.78);
}

/*.rectangle-success {*/
/*  position: absolute;*/
/*  width: 120px;*/
/*  height: 60px;*/
/*  background: #FF8080;*/
/*  border-radius: 7px;*/
/*  border-color: #FF8080;*/
/*}*/

.rectangle-success {
  /*position: absolute;*/
  /*width: 120px;*/
  /*height: 60px;*/
  background: rgba(0, 171, 48, 0.6);
  border-radius: 7px;
  border-color: rgba(0, 171, 48, 0.6);
}

.rectangle-pending {
  /*position: absolute;*/
  /*width: 120px;*/
  /*height: 60px;*/
  background: #ffab70;
  border-radius: 7px;
  border-color: #ff9447;
}

.rectangle-no-action {
  /*position: absolute;*/
  /*width: 120px;*/
  /*height: 60px;*/
  background: #c4c4c4;
  border-radius: 7px;
}

.verify-all-btn {
  /* background-color: rgb(38, 44, 102); */
  /* color: rgb(255, 255, 255); */
  float: right;
  margin-top: 15px;
}

.attendance-button {
  position: relative;
}
.attendance-button:hover .attendance-button-tooltip {
  display: flex;
}
.attendance-button-tooltip::before {
  color: #8e8b8f;
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #8e8b8f transparent;
}
.attendance-button-tooltip {
  display: none;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
  position: absolute;
  background: #8e8b8f;
  color: #fff;
  width: 101px;
  height: 46px;
  font-size: 11px;
  line-height: 14px;
  top: 56px;
  left: 6px;
  text-align: center;
  border-radius: 2px;
  z-index: 5;
}

.unlisted-attendance-icon {
  position: absolute;
  top: 2px;
  right: 4px;
  font-size: 14px;
}

.unlisted-attendance {
  opacity: 0.6;
}

img.rounded.float-end {
  height: 20px;
  width: 20px;
  margin: 3px 0px 1px 9px;
}

nav-link {
  position: absolute;
  width: 84px;
  height: 14px;
  left: 76px;
  top: 177px;

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #000000;
}

/*i.bi.bi-arrow-repeat::before {*/
/*  animation: spin 2s linear infinite;*/
/*}*/

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

i::before {
  font-weight: bold;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

<style>
.billGenerateMsg {
  text-align: left;
}
.billGenerateMsg b {
  line-height: 25px;
}
.billGenerateMsg ul {
  padding-left: 1rem;
}
.billGenerateMsg li {
  list-style: none;
  font-size: 15px;
}
</style>
